export const step: string[] = ["Data approvazione USP", "Approvazione UTBOP", "Caricamento PO", "Approvazione PO"];

export enum EMAIL_BOX {
    title = 'Descrivi il problema riscontrato ed invia una mail al service desk.'
}
